export enum CreditLimitPreferenceTypes {
	AutoIncrease = 'autoincrease',
	CheckWithMe = 'checkwithme',
}
